import React, { useState } from "react";
import cx from "classnames";
import Button, { ButtonTypes } from "../../common/components/Forms/Button/Button";
import AFSkipQuestionDialog from "./Modals/AFSkipQuestionDialog";

interface IAFNavigationProps {
    backIsVisible?: boolean;
    handleBack: (e) => void;
    skipIsVisible: boolean;
    showSkipDialog?: boolean;
    handleSkip?: () => void;
    forwardIsVisible: boolean;
    forwardIsSubmitting?: boolean;
    forwardIsDisabled: boolean;
    forwardType: ButtonTypes
    onClick?: () => void;
    forwardText: string;
    className?: string; //TODO: Remove the reliance on this during the V3 design changes
}

const AFNavigation: React.FC<IAFNavigationProps> = (props) => {
    const { handleBack, skipIsVisible, showSkipDialog, handleSkip, forwardIsVisible, forwardIsSubmitting, forwardIsDisabled, forwardText, forwardType, onClick, className } = props;
    const backIsVisible = props.backIsVisible === undefined || props.backIsVisible === true;

    const [isOpenDialog, setIsOpenDialog] = useState(false);

    const handleDialog = (): void => {
        if (showSkipDialog) {
            setIsOpenDialog(true);
        } else {
            handleSkip();
        }
    }

    return (
        <>
            <AFSkipQuestionDialog
                isOpen={isOpenDialog}
                handleSkip={handleSkip}
                onClose={() => setIsOpenDialog(false)}
            />
            <div className={cx({
                "layout-row-right-aligned": !backIsVisible,
                "layout-flex-row--justify-spaced": backIsVisible},
                "layout-button-row", "panel-button-row", className)}>
                {backIsVisible && (
                    <button
                        type="button"
                        className={cx("text-back-link", "btn-link")}
                        onClick={handleBack}>
                        Back
                    </button>
                )}
                <div className={cx("btn-next-container")}>
                    {forwardIsVisible && (
                        <Button
                            className={cx("btn-primary")}
                            width="content"
                            component="button"
                            size="m"
                            type={forwardType}
                            onClick={onClick}
                            isSubmitting={forwardIsSubmitting}
                            isDisabled={forwardIsDisabled}
                            variant="calltoaction">
                            <span>
                                {forwardText}
                            </span>
                        </Button>
                    )}
                </div>
                {skipIsVisible && (
                    <button
                        type="button"
                        className={cx("text-back-link", "btn-link")}
                        onClick={handleDialog}>
                        Skip
                    </button>
                )}
            </div>
        </>
    );
};

export default AFNavigation;